export enum UserRole {
  Individual = 1,
  LegalPerson = 2,
  B2BLease = 3
}
